// The same style variables are using in src\ui\assets\styles\base\variables\breakpoints.scss
const XS_WIDTH = 480;
const SM_WIDTH = 660;
const MD_WIDTH = 768;
const LG_WIDTH = 960;
const TAB_WIDTH = 1024;
const XL_WIDTH = 1200;
const XXL_WIDTH = 1400;
const XXXL_WIDTH = 1640;

export { LG_WIDTH as L, MD_WIDTH as M, SM_WIDTH as S, TAB_WIDTH as T, XS_WIDTH as X, XL_WIDTH as a, XXL_WIDTH as b, XXXL_WIDTH as c };
//# sourceMappingURL=breakpoints-X1SKRYyW.js.map
